// extracted by mini-css-extract-plugin
export default {"main":"stepcheck_main__+ht5R","checked":"stepcheck_checked__YivYI","hilighted":"stepcheck_hilighted__bnRq1","clicable":"stepcheck_clicable__UB5gq"};